import SearchFormController from "./search_form_controller"

/**
 * Quote Search Controller - Extends search form controller with quote-specific functionality
 */
export default class extends SearchFormController {
  static targets = [
    'endcustomer','customer','city','street','number','zipcode', 'nobids','wbids', 'singlep',
    'diversity', 'pending', 'ready', 'known', 'nogeo', 'priority'
  ]

  connect() {
    super.connect()
    this.enforceInitialExclusivity()
  }

  enforceInitialExclusivity() {
    if (this.hasNobidsTarget && this.nobidsTarget.checked) this.enforceExclusivity(this.nobidsTarget)
    else if (this.hasWbidsTarget && this.wbidsTarget.checked) this.enforceExclusivity(this.wbidsTarget)
    else if (this.hasSinglepTarget && this.singlepTarget.checked) this.enforceExclusivity(this.singlepTarget)
    else if (this.hasDiversityTarget && this.diversityTarget.checked) this.enforceExclusivity(this.diversityTarget)

    if (this.hasPendingTarget && this.pendingTarget.checked) this.enforceExclusivity(this.pendingTarget)
    else if (this.hasReadyTarget && this.readyTarget.checked) this.enforceExclusivity(this.readyTarget)
  }

  enforceExclusivity(target) {
    if (!target || !target.checked) return

    if (target === this.pendingTarget) {
      if (this.hasReadyTarget) this.readyTarget.checked = false
    } else if (target === this.readyTarget) {
      if (this.hasPendingTarget) this.pendingTarget.checked = false
    }

    if (target === this.nobidsTarget) {
      if (this.hasWbidsTarget) this.wbidsTarget.checked = false
      if (this.hasSinglepTarget) this.singlepTarget.checked = false
      if (this.hasDiversityTarget) this.diversityTarget.checked = false
    } else if (target === this.wbidsTarget) {
      if (this.hasNobidsTarget) this.nobidsTarget.checked = false
      if (this.hasSinglepTarget) this.singlepTarget.checked = false
      if (this.hasDiversityTarget) this.diversityTarget.checked = false
      if (this.hasKnownTarget) this.knownTarget.checked = false
    } else if (target === this.singlepTarget) {
      if (this.hasNobidsTarget) this.nobidsTarget.checked = false
      if (this.hasWbidsTarget) this.wbidsTarget.checked = false
      if (this.hasDiversityTarget) this.diversityTarget.checked = false
      if (this.hasKnownTarget) this.knownTarget.checked = false
    } else if (target === this.diversityTarget) {
      if (this.hasNobidsTarget) this.nobidsTarget.checked = false
      if (this.hasWbidsTarget) this.wbidsTarget.checked = false
      if (this.hasSinglepTarget) this.singlepTarget.checked = false
      if (this.hasKnownTarget) this.knownTarget.checked = false
    } else if (target === this.knownTarget) {
      if (this.hasWbidsTarget) this.wbidsTarget.checked = false
      if (this.hasSinglepTarget) this.singlepTarget.checked = false
      if (this.hasDiversityTarget) this.diversityTarget.checked = false
    }
  }

  toggle(event) {
    if (event) {
      event.stopPropagation()
      this.enforceExclusivity(event.target)
    }
    this.envia()
  }

  onCustomerChange() {
    const query = this.customerTarget.value.trim()
    if ( query.length < 3) return
    this.envia()
  }

  // Generic field reset, driven by a Stimulus action param, e.g.:
  // data-action="click->quote-search#resetField" data-quote-search-field-param="customer"
  resetField({ params: { field } }) {
    const target = this[`${field}Target`]
    if (!target) return
    target.value = ""
    this.envia()
  }

  envia() {
    this.element.requestSubmit()
  }

  buildSearchParams() {
    const params = new URLSearchParams()
    const formData = new FormData(this.element)
    
    for (const [key, value] of formData.entries()) {
      if (value && value.trim()) {
        params.append(key, value.trim())
      }
    }
    return params
  }

  entityType() {
    return 'quote'
  }

  disconnect() {
    super.disconnect()
  }
}
